//可以做一些默认配置 扩展功能 
const defaults = {
  title:'',
  message:'',
  type:'',
  beforeClose:'',
  center:true,
  iscancel:false
  //....
}
// 创建组件实例
import Vue from 'vue'
import tipsDialog from "@/components/common/popup/tipsDialog";
let currentMsg, instance
let msgQueue = [];
//通过extend 创建一个构造函数 
const InstanceCtor = Vue.extend(tipsDialog)
const defaultCallback = action => {
if (currentMsg) {
  let callback = currentMsg.callback
  // 不传就是undefined
  if (typeof callback === 'function') {
    callback(action)
  }
  if (currentMsg.resolve) {
    if (action === 'confirm') {
      if (instance.showInput) {
        currentMsg.resolve({ value: instance.inputValue, action })
      } else {
        currentMsg.resolve(action)
      }
    } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
      currentMsg.reject(action)
    }
  }
}
}
// 创建实例
function initInstance (propsData) {
instance = new InstanceCtor({
  el: document.createElement('div') // 如果不传el new vue的时候不会需要执行$mount挂载
})
instance.callback = defaultCallback
}
// 打开对话框
function showDialog () {
if (!instance) { // 可以看出 instance只有一个实例 单例模式
  initInstance()
}
instance.action = ''
if (!instance.visible) { 
//visible判断配合下面执行的nexttick visible=true涉及到任务队列  
//如果同步多次调用同一eventloop触发多次showdialog的时候判断visible都会
//是false msgQueue长度都会大于0 进入下面的判断给实例赋值 
//currentMsg只会是eventloop最后一个实例的配置这时候弹窗展示的都会是最后这个的信息内容
//如果异步多次调用 涉及下面callback重新被改造
  if (msgQueue.length > 0) {
    currentMsg = msgQueue.shift()// 移出队列第一项，拿到参数信息
    let options = currentMsg.options
    for (const prop in options) {
      if (Object.hasOwnProperty.call(options, prop)) {
        instance[prop] = options[prop]
      }
    }
    if (options.callback === undefined) {
      instance.callback = defaultCallback
    }
    let oldCb = instance.callback // 从新对 callback 进行制定
    instance.callback = (action, instance) => { 
    // callback是按钮点击触发doclose执行的 visible = false  
    //然后settimeout 执行callback这时候会再次调用showdialog 第一个执行showdialog后 nexttick visible = true 早于settimeout执行
    //所以后面的msg执行showdialog时无法进入!visible == true的判断 也就无法替换instance的信息展示无法弹出msgQueue  
    //所以msgQueue也就缓存着多个后面多个未执行的Msg 
    //当点击确认 取消关闭弹窗的操作触发doclose时候也就短暂使得visible为false //diclose执行callback的时候也就可以进入!visible == true 
    //且msgQueue.length > 0的判断 弹出msgQueue 让currentMsg指针指向msgQueue队列刚弹出的这个msg 替换instance展示的内容 
    //重新赋值instance的callback 回调触发时重复上面的操作 直到msgqueue清空
      oldCb(action, instance)
      showDialog()// 进行了递归调用，消耗队列
    }
    // 给插槽default位置放vnode
    if (isVNode(instance.message)) {
      instance.$slots.default = [instance.message]// 触发更新
      instance.message = null
    } else {
      delete instance.$slots.default
    }
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.visible = true
    })
  }
}
}
function hasOwn (obj, key) {
const hasOwnProperty = Object.prototype.hasOwnProperty
return hasOwnProperty.call(obj, key)
};
function isVNode (node) {
return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions')
};

const MessageBox = function (options, callback) {
console.log('....', new Date().getTime())
if (Vue.prototype.$isServer) return
if (typeof options === 'string' || isVNode(options)) {
  options = {
    message: options
  }
  if (typeof arguments[1] === 'string') {
    options.title = arguments[1]
  }
  // callback 是在methods的doclose被调用的时候执行的
} else if (options.callback && !callback) {
  callback = options.callback
}
return new Promise((resolve, reject) => {
  msgQueue.push({
    options: Object.assign({}, defaults,options),
    resolve,
    reject
  })
  showDialog()
})
}
export default MessageBox
export { MessageBox }